import { ChangeDetectorRef, Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
/*import { liveQuery } from 'dexie';
import { Application } from 'src/app/classes/application';
import { Burial } from 'src/app/classes/burial';*/
import { FilterValue } from 'src/app/classes/filter-value';
import { BroadcastEvents } from 'src/app/enums/broadcast-events';
import { BurialLayoutType } from 'src/app/enums/burial-layout-type';
import { ElementAttribute } from 'src/app/enums/element-attribute';
import { FilterValueType } from 'src/app/enums/filter-value-type';
import { RestApiEndpoints } from 'src/app/enums/rest-api-endpoints';
import { SelectedBurialsTab } from 'src/app/enums/selected-burials-tab';
import { BroadcastService } from 'src/app/services/broadcast.service';
import { BurialsService } from 'src/app/services/burials.service';
import { CredentialsService } from 'src/app/services/credentials.service';
//import { DatabaseService } from 'src/app/services/database.service';
import { FileService } from 'src/app/services/file.service';
import { ModalService } from 'src/app/services/modal.service';
import { PDFService } from 'src/app/services/pdf.service';
import { RestApiService } from 'src/app/services/rest-api.service';
import SignaturePad from 'signature_pad';
import { DateService } from '../../../services/date.service';

declare var $: any;

declare function initSelect(): void;
declare function initCollapsible(): void;
declare function initToolTip(): void;
declare function initFormsDropDown(): void;
declare function initTabs(): void;
declare function initSendContractDropDown(): void;
declare function initLeanModal(): void;
declare function makeToast(message: string): void;
declare function openModalWithID(modalID: string): void;
declare function closeModalWithID(modalID: string): void;
declare function genereateQRCodeInFieldWithId(elementID: string, qrString: string): void;
declare function handleTempModalData(tempModalData: any): any;
declare function handleCurrentDeathDate(currentDeathDate: any): any;
declare function handleCurrentDeathTime(currentDeathTime: any): any;
declare function updateMaterialTextFields(): void;
declare function scrollModalToTop(): void;
declare function cleanInput(inputString: string, shouldURLEncode: boolean): string;
declare function setReadonlyOnInputsToState(readonlyState: boolean, isForced: boolean): void;
declare function openCameraWithID(inputID: string): void;
declare function initBurialsApplicationValues(): void;
declare function setSelectValue(select: string, value: string): void;

@Component({
    selector: 'app-burials',
    templateUrl: './burials.component.html',
    styleUrls: ['./burials.component.css']
})
export class BurialsComponent implements AfterViewInit {
    isLoading: boolean = false;
    isHistoryLoading: boolean = false;
    isDocumentLoading: boolean = false;
    isOptionsLoading: boolean = false;
    //private applications$ = liveQuery(() => this.databaseService.applications.toArray());
    private tmpApplications: any[] = [];
    applications: any[] = [];
    //private burials$ = liveQuery(() => this.databaseService.burials.toArray());
    private tmpBurials: any[] = [];
    burials: any[] = [];
    drafts: any[] = [];
    locations: any[] = [];
    historyEntries: any = [];
    selectedApplication: any;
    selectedBurial: any = {};
    takeImageOptions: any = {};
    hoveredImageField = null;
    agreementTextColor: string = 'black-text';
    filePreviewObject: any = null;
    private currentAlternativeID = localStorage.getItem('sessionID');
    private printAfterSaveID = null;
    showSendNPrint: boolean = false;
    inputSendMail: boolean = false;
    inputAgreement: boolean = false;
    currentLocationName: string = 'Aktueller Standort';
    isIEBrowser: boolean = false;
    isReadOnly: boolean = false;
    filterValues: FilterValue[] = [];
    filterInputContractNames: string[] = [];
    burialAddModalTitle: string = 'Neuer Auftrag';
    burialAddModalTabBarVisible: boolean = true;
    isApplicationOnline: boolean = false;
    inputSearchText: string = '';
    currentStep: number = 1;
    readonly totalSteps: number = 3;
    readonly tabOrder: string[] = ['application', 'attachments', 'dates'];
    @ViewChild('bestatterSignature') bestatterSignatureElement!: ElementRef;
    @ViewChild('angehoerigerSignature') angehoerigerSignatureElement!: ElementRef;
    
    private bestatterSignaturePad!: SignaturePad;
    private angehoerigerSignaturePad!: SignaturePad;
    private bestatterSignature: string = '';
    private angehoerigerSignature: string = '';
    private currentPrintLabelType: string = '';
    isDialogOpen: boolean = false;
    isConfirmDialogOpen: boolean = false;
    filterMatchCount: number = 0;

    constructor(private credentialService: CredentialsService,
        private burialsService: BurialsService,
        private credentialsService: CredentialsService,
        private broadcastService: BroadcastService,
        private pdfService: PDFService,
        private restApiService: RestApiService,
        private modalService: ModalService,
        private router: Router,
        private fileService: FileService,
        private changeDetectorRef: ChangeDetectorRef,
        private dateService: DateService) {
//,
//private databaseService: DatabaseService

        this.isApplicationOnline = credentialService.isApplicationOnline;
        this.broadcastService.on(BroadcastEvents.networkStateChanged).subscribe(() => {
            this.isApplicationOnline = credentialService.isApplicationOnline;

            const networkStateToastMessage = this.credentialsService.isApplicationOnline ? "Die Anwendung is online" : "Die Anwendung is offline";
            makeToast(networkStateToastMessage);

            this.initialInitOfMaterialComponents();
        });

        const userName = localStorage.getItem('userName');
        if (userName && userName.length > 0) {
            this.currentLocationName = userName;
        }

        const standorte = localStorage.getItem('standorte');
        if (standorte) {
            var tmpLocations = JSON.parse(standorte);

            if (tmpLocations && tmpLocations.length > 0) {
                this.locations = tmpLocations;
            }
        }

        this.isIEBrowser = credentialService.isIEBrowser();
    }

    ngAfterViewInit() {
        this.initialInitOfMaterialComponents();
        
        // Warte auf das nächste Event-Loop-Tick, um sicherzustellen, dass die DOM-Elemente bereit sind
        setTimeout(() => {
            // Überprüfe, ob die Canvas-Elemente existieren
            const bestatterCanvas = document.getElementById('bestatterSignature');
            const angehoerigerCanvas = document.getElementById('angehoerigerSignature');
            
            if (bestatterCanvas && angehoerigerCanvas) {
                this.initializeSignaturePads();
            } else {
                // Wenn die Elemente noch nicht existieren, versuche es erneut
                setTimeout(() => {
                    this.initializeSignaturePads();
                }, 100);
            }
        }, 0);
        
        setTimeout(() => {
            this.reloadBurials(true);
        }, 0);
    }

    private initialInitOfMaterialComponents() {
        initSelect();
        initTabs();
        initSendContractDropDown();
        initLeanModal();
        initToolTip();
        initCollapsible();
    }

    private initializeSignaturePads() {
        
        // Bestatter SignaturePad initialisieren
        const bestatterCanvas = document.getElementById('bestatterSignature');
        if (bestatterCanvas) {
            this.bestatterSignaturePad = new SignaturePad(bestatterCanvas as HTMLCanvasElement, {
                backgroundColor: 'rgb(255, 255, 255)',
                penColor: 'rgb(0, 0, 0)',
                minWidth: 1,
                maxWidth: 2.5,
                throttle: 16,
                velocityFilterWeight: 0.7
            });
            
            // Event-Listener für Touch- und Maus-Events hinzufügen
            bestatterCanvas.addEventListener('touchstart', (e) => {
                e.preventDefault();
            }, { passive: false });
            bestatterCanvas.addEventListener('touchmove', (e) => {
                e.preventDefault();
            }, { passive: false });
            bestatterCanvas.addEventListener('touchend', () => {
            });
            
            // Koordinatenkorrektur für Bestatter
            this.fixSignaturePadCoordinates(this.bestatterSignaturePad, bestatterCanvas as HTMLCanvasElement);
            
            // Event-Listener für Modal-Öffnung und Fenstergrößenänderung
            window.addEventListener('resize', () => {
                this.resizeSignaturePad(this.bestatterSignaturePad, bestatterCanvas as HTMLCanvasElement);
            });
        } else {
            console.error('Bestatter Canvas nicht gefunden');
        }
        
        // Angehöriger SignaturePad initialisieren
        const angehoerigerCanvas = document.getElementById('angehoerigerSignature');
        if (angehoerigerCanvas) {
            this.angehoerigerSignaturePad = new SignaturePad(angehoerigerCanvas as HTMLCanvasElement, {
                backgroundColor: 'rgb(255, 255, 255)',
                penColor: 'rgb(0, 0, 0)',
                minWidth: 1,
                maxWidth: 2.5,
                throttle: 16,
                velocityFilterWeight: 0.7
            });
            
            // Event-Listener für Touch- und Maus-Events hinzufügen
            angehoerigerCanvas.addEventListener('touchstart', (e) => {
                e.preventDefault();
            }, { passive: false });
            angehoerigerCanvas.addEventListener('touchmove', (e) => {
                e.preventDefault();
            }, { passive: false });
            angehoerigerCanvas.addEventListener('touchend', () => {
            });
            
            // Koordinatenkorrektur für Angehöriger
            this.fixSignaturePadCoordinates(this.angehoerigerSignaturePad, angehoerigerCanvas as HTMLCanvasElement);
            
            // Event-Listener für Modal-Öffnung und Fenstergrößenänderung
            window.addEventListener('resize', () => {
                this.resizeSignaturePad(this.angehoerigerSignaturePad, angehoerigerCanvas as HTMLCanvasElement);
            });
        } else {
            console.error('Angehöriger Canvas nicht gefunden');
        }
    }
    
    private resizeSignaturePad(signaturePad: SignaturePad, canvas: HTMLCanvasElement) {
        // Speichere die aktuelle Unterschrift
        const data = signaturePad.toData();
        
        // Setze die Canvas-Größe zurück
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext('2d')?.scale(ratio, ratio);
        
        // Initialisiere das SignaturePad neu
        signaturePad.clear();
        signaturePad.fromData(data);
    }

    // Methode zur Korrektur der Koordinaten
    private fixSignaturePadCoordinates(signaturePad: SignaturePad, canvas: HTMLCanvasElement) {
        // Überschreibe die _getCoordinates-Methode von SignaturePad
        const originalGetCoordinates = (signaturePad as any)._getCoordinates;
        (signaturePad as any)._getCoordinates = (event: any) => {
            const rect = canvas.getBoundingClientRect();
            const coordinates = originalGetCoordinates.call(signaturePad, event);
            
            // Berechne das Verhältnis zwischen der tatsächlichen Canvas-Größe und der angezeigten Größe
            const ratioX = canvas.width / rect.width;
            const ratioY = canvas.height / rect.height;
            
            // Korrigiere die Koordinaten unter Berücksichtigung des Canvas-Offsets
            return {
                x: (coordinates.x - rect.left) * ratioX,
                y: (coordinates.y - rect.top) * ratioY
            };
        };

        // Setze die Canvas-Größe basierend auf der tatsächlichen Anzeigegröße
        const resizeCanvas = () => {
            const ratio = Math.max(window.devicePixelRatio || 1, 1);
            canvas.width = canvas.offsetWidth * ratio;
            canvas.height = canvas.offsetHeight * ratio;
            canvas.getContext('2d')?.scale(ratio, ratio);
            signaturePad.clear(); // Lösche die Unterschrift bei Größenänderung
        };

        // Initialisiere die Größe
        resizeCanvas();

        // Füge Event-Listener für Größenänderungen hinzu
        window.addEventListener('resize', resizeCanvas);
    }

    checkImport() {
        var unsafeID = this.credentialService.importContractID;
        if (unsafeID == null) { return; }
        var unsafeSelectWorked = this.didSelectApplicationWithID(unsafeID);
        if (unsafeID && unsafeSelectWorked) {
            this.openContractButtonClicked();
        } else if (unsafeID && !unsafeSelectWorked) {
            makeToast("Der zu importieren versuchte Antrag wurde nicht gefunden");
        }
    }

    checkPrintAfterSave() {
        if (!this.printAfterSaveID) { return; }

        var printObject = this.burialsService.parseApplicationByID(this.printAfterSaveID, this.applications);
        this.printAfterSaveID = null;
        if (!printObject) { return; }

        var that = this;
        this.isOptionsLoading = true;
        this.pdfService.createDocumentOfType('RTK.Antrag', printObject, function (result: any) {
            that.isOptionsLoading = false;
            if (!result) {
                return;
            }
            openModalWithID('filedetailmodal');
            that.filePreviewObject = result;
        });
    }

    reloadBurials(appendRequest: boolean = false) {
        if (!this.isApplicationOnline) {
            makeToast('Es können keine Aufträge geladen werden da die Anwendung offline ist');
            return;
        }

        if (!appendRequest) {
            this.tmpApplications = [];
            this.applications = [];
            this.tmpBurials = [];
            this.burials = [];
            this.drafts = [];
        }

        var burialIDs = [0];
        var applicationIDs = [0];

        for (var burialIndex in this.tmpBurials) {
            if (!this.tmpBurials[burialIndex].hasOwnProperty('fid')) {
                continue;
            }
            burialIDs.push(Number(this.tmpBurials[burialIndex].fid));
        }

        for (var applicationIndex in this.tmpApplications) {
            if (!this.tmpApplications[applicationIndex].hasOwnProperty('burialData') || !this.tmpApplications[applicationIndex].burialData.hasOwnProperty('qrstring')) {
                continue;
            }
            applicationIDs.push(this.tmpApplications[applicationIndex].burialData.qrstring);
        }

        const inputLocationField = this.credentialService.parseElementBy(ElementAttribute.class, 'inputLocation');
        if (!inputLocationField) { return; }

        this.currentAlternativeID = inputLocationField.value;

        if (!this.currentAlternativeID || this.currentAlternativeID == '0') {
            this.currentAlternativeID = localStorage.getItem('sessionID');
        }

        var postBody = {
            burialIDs: burialIDs.join('I'),
            applicationIDs: applicationIDs.join('I'),
            alternativeID: this.currentAlternativeID
        };

        this.isLoading = true;
        this.restApiService.sendAsyncRequestToEndpoint(RestApiEndpoints.burials, postBody, (success, response) => {
            this.isLoading = false;

            if (!success) {
                makeToast(response);
                return;
            }

            if (response.payload.contracts) {
                for (var burialIndex in response.payload.contracts) {
                    this.tmpBurials.push(response.payload.contracts[burialIndex]);
                    this.modalService.deleteDataObjectFromDrafts(response.payload.contracts[burialIndex]);
                }

                this.tmpBurials = this.burialsService.prepareBurialArray(this.tmpBurials);
            }

            if (response.payload.applications) {
                for (var applicationIndex in response.payload.applications) {
                    this.tmpApplications.push(response.payload.applications[applicationIndex]);
                    this.modalService.deleteDataObjectFromDrafts(response.payload.applications[applicationIndex]);
                }
                this.tmpApplications = this.burialsService.prepareApplicationArray(this.tmpApplications);
            }
            if (response.payload.timeblocks) {
                this.credentialService.setBlockedDates(response.payload.timeblocks);
            }

            this.drafts = this.modalService.loadDataObjectsFromDrafts();
            //this.didChangeLocation(true);

           this.applications = this.tmpApplications;
           this.burials = this.tmpBurials;

            initCollapsible();
            initToolTip();
            initFormsDropDown();
            this.checkImport();
            this.checkPrintAfterSave();
        });
    }

    didSelectTabWithID(tabID: string) {
        // Setze den ausgewählten Tab im modalService
        switch (tabID) {
            case 'application':
                this.modalService.selectedTab = SelectedBurialsTab.application;
                break;
            case 'attachments':
                this.modalService.selectedTab = SelectedBurialsTab.attachments;
                break;
            case 'dates':
                this.modalService.selectedTab = SelectedBurialsTab.dates;
                break;
            case 'quick':
                this.modalService.selectedTab = SelectedBurialsTab.quick;
                break;
            case 'personal_data':
                this.modalService.selectedTab = SelectedBurialsTab.personalData;
                break;
            case 'urn_delivery':
                this.modalService.selectedTab = SelectedBurialsTab.urnDelivery;
                break;
            case 'client':
                this.modalService.selectedTab = SelectedBurialsTab.client;
                break;
        }

        // Aktualisiere die Material-Komponenten
        setTimeout(() => {
            initTabs();
            updateMaterialTextFields();
        }, 100);

        // Setze den currentStep entsprechend dem ausgewählten Tab
        if (tabID === 'application') {
            this.currentStep = 1;
        } else if (tabID === 'attachments') {
            this.currentStep = 2;
        } else if (tabID === 'dates') {
            this.currentStep = 3;
        }
    }

    goToNextStep() {
        if (this.currentStep < this.totalSteps) {
            this.currentStep++;
            this.didSelectTabWithID(this.tabOrder[this.currentStep - 1]);
        } else if (this.currentStep === this.totalSteps) {
            // Wenn wir im letzten Schritt sind, können wir den Senden-Button aktivieren
            this.sendDataButtonClicked();
        }
    }

    goToPreviousStep() {
        if (this.currentStep > 1) {
            this.currentStep--;
            this.didSelectTabWithID(this.tabOrder[this.currentStep - 1]);
        }
    }

    resetSteps() {
        this.currentStep = 1;
    }

    getCurrentStep(): number {
        return this.currentStep;
    }

    didSelectBurialWithID(burialID: number) {
        this.showSendNPrint = false;
        this.selectedBurial = this.burialsService.parseBurialByID(burialID, this.burials);

        if (this.selectedBurial.v_qrstring) {
            genereateQRCodeInFieldWithId('globalQRCode', this.selectedBurial.v_qrstring);
        }

        if (this.selectedBurial && this.selectedBurial.hasOwnProperty('v_deathday')) {
            handleCurrentDeathDate(this.selectedBurial.v_deathday);
        } else {
            handleCurrentDeathDate('null');
            handleCurrentDeathTime('null');
        }

        if (this.selectedBurial && this.selectedBurial.hasOwnProperty('v_deathtime')) {
            handleCurrentDeathTime(this.selectedBurial.v_deathtime);
        } else {
            handleCurrentDeathTime('null');
        }
    }

    didSelectApplicationWithID(applicationID: number | string): boolean {
        this.showSendNPrint = false;
        var selectedApplication = this.burialsService.parseApplicationByID(applicationID, this.applications);
        this.isReadOnly = false;

        if (!selectedApplication) { return false; }

        this.isReadOnly = true;
        this.selectedApplication = selectedApplication;

        if (this.selectedApplication.burialData.qrstring) {
            genereateQRCodeInFieldWithId('globalQRCode', this.selectedApplication.burialData.qrstring);
        }

        if (this.selectedApplication && this.selectedApplication.burialData.hasOwnProperty('inputDeathDate')) {
            handleCurrentDeathDate(this.selectedApplication.inputDeathDate);
        } else {
            handleCurrentDeathDate('null');
            handleCurrentDeathTime('null');
        }

        if (this.selectedApplication && this.selectedApplication.burialData.hasOwnProperty('inputDeathTime')) {
            handleCurrentDeathTime(this.selectedApplication.inputDeathTime);
        } else {
            handleCurrentDeathTime('null');
        }

        return true;
    }

    didSelectDraftWithID(draftID: any): boolean {
        if (!draftID) {
            return false;
        }
        
        this.showSendNPrint = false;
        var selectedDraft = this.burialsService.parseApplicationByID(draftID, this.drafts);
        
        if (!selectedDraft) {
            return false;
        }
        
        this.isReadOnly = false;
        this.selectedApplication = selectedDraft;
        this.selectedApplication.isDraft = true;
        this.selectedBurial = null;

        if (this.selectedApplication.burialData && this.selectedApplication.burialData.qrstring) {
            genereateQRCodeInFieldWithId('globalQRCode', this.selectedApplication.burialData.qrstring);
        }

        if (this.selectedApplication.burialData && this.selectedApplication.burialData.hasOwnProperty('inputDeathDate')) {
            handleCurrentDeathDate(this.selectedApplication.burialData.inputDeathDate);
        } else {
            handleCurrentDeathDate('null');
            handleCurrentDeathTime('null');
        }

        if (this.selectedApplication.burialData && this.selectedApplication.burialData.hasOwnProperty('inputDeathTime')) {
            handleCurrentDeathTime(this.selectedApplication.burialData.inputDeathTime);
        } else {
            handleCurrentDeathTime('null');
        }
        
        this.changeDetectorRef.detectChanges();
        return true;
    }

    openNewContractButtonClicked() {
        this.inputSendMail = false;
        const sendMail = localStorage.getItem('sendMail');
        if (sendMail) {
            this.inputSendMail = JSON.parse(sendMail);
        }

        this.inputAgreement = false;
        this.showSendNPrint = true;
        this.modalService.initNewBurialModal();
        this.didSelectTabWithID('application');
        this.isDialogOpen = true;
        initTabs();
    }

    openNewQuickContractButtonClicked() {
        this.inputSendMail = false;
        const sendMail = localStorage.getItem('sendMail');
        if (sendMail) {
            this.inputSendMail = JSON.parse(sendMail);
        }

        this.inputAgreement = false;
        this.showSendNPrint = true;
        this.modalService.initNewBurialModal();
        this.didSelectTabWithID('quick');
        initTabs();
    }

    openContractButtonClicked() {
        if (!this.selectedApplication || !this.selectedApplication.burialData) {
            makeToast('Bitte zuerst einen Entwurf oder Auftrag auswählen (auf die Zeile klicken).');
            return;
        }
        this.inputAgreement = false;
        this.showSendNPrint = true;
        this.isDialogOpen = true;

        if (this.selectedApplication.burialData.qrstring) {
            handleTempModalData(this.selectedApplication);
        }

        this.modalService.initNewBurialModal(this.selectedApplication);
        this.didSelectTabWithID('application');
        this.changeDetectorRef.detectChanges();
    }

    openDetailsButtonClicked(burial?: any) {
        const burialToShow = burial ?? this.selectedBurial;
        if (!burialToShow) {
            return;
        }
        this.selectedBurial = burialToShow;
        this.didSelectTabWithID('personal_data');
        openModalWithID('burialdetailmodal');
        initTabs();
        this.modalService.initBurialInfoModal(burialToShow);
        scrollModalToTop();
    }

    /**
     * Öffnet ein Dokument aus einem lokal gespeicherten Entwurf (Draft).
     * Die Dokumente sind als Base64-PDF im burialDocs gespeichert.
     */
    openDraftDocument(draft: any, documentKey: string) {
        if (!draft?.burialDocs?.[documentKey]) {
            makeToast('Dokument konnte nicht geöffnet werden');
            return;
        }
        const base64Data = draft.burialDocs[documentKey];
        // Base64-String muss ggf. data-URL-Format haben für PDF-Anzeige
        const dataUrl = base64Data.startsWith('data:') ? base64Data : `data:application/pdf;base64,${base64Data}`;
        window.open(dataUrl, '_blank');
    }

    /**
     * Erlaubnis zur Einäscherung (Backend: dok_todesbescheinigung_pdf / dok_todesbescheinigung_ga):
     * nur Anzeige, kein Upload durch das Bestattungsunternehmen.
     */
    private isErlaubnisZurEinaescherungViewOnly(documentID: string): boolean {
        return documentID === 'deathapprovalData' || documentID === 'i_deathapprovalData';
    }

    private loadBurialDocumentForPreview(documentID: string, documentType: string, imageID: string): void {
        var postBody = {
            id: cleanInput(imageID, true),
            type: cleanInput(documentType, true),
            document: cleanInput(documentID, true)
        };

        this.filePreviewObject = null;
        this.isDocumentLoading = true;

        openModalWithID('filedetailmodal');

        this.restApiService.sendAsyncRequestToEndpoint(RestApiEndpoints.loadDocument, postBody, (success, response) => {
            this.isDocumentLoading = false;

            if (!success) {
                makeToast('Dokument konnte nicht geladen werden, bitte erneut versuchen');
                return;
            }

            if (response.success) {
                this.filePreviewObject = response.payload;
            } else {
                makeToast('Dokument konnte nicht geladen werden, bitte erneut versuchen');
            }
        });
    }

    /** Dokumente, die aus Datenschutzgründen nur erfasst, nicht in der Vorschau geöffnet werden. */
    private static readonly uploadOnlyDocumentIds = ['i_deathapprovalsecretData', 'deathapprovalsecretData'];

    takeImageClicked(documentID: string, documentType: string) {
        if (!this.selectedBurial && !this.selectedApplication) {
            return;
        }

        var imageID = null;

        switch (documentType) {
            case 'application':
                if (this.selectedApplication.hasOwnProperty('burialData') && this.selectedApplication.burialData.hasOwnProperty('qrstring') && this.selectedApplication.hasOwnProperty('burialDocs') && this.selectedApplication.burialDocs.hasOwnProperty(documentID) && this.selectedApplication.burialDocs[documentID]) {
                    imageID = this.selectedApplication.burialData.qrstring;
                }
                break;
            case 'burial':
                if (this.selectedBurial.hasOwnProperty(documentID)) {
                    imageID = this.selectedBurial[documentID];
                }
                if (imageID == '2') {
                    imageID = this.selectedBurial.fid;
                }
                break;
        }

        if (BurialsComponent.uploadOnlyDocumentIds.indexOf(documentID) >= 0) {
            this.takeImageOptions = {
                documentid: documentID,
                documenttype: documentType
            };
            setReadonlyOnInputsToState(false, false);
            openCameraWithID('takePictureField');
            return;
        }

        const viewOnlyErlaubnis = this.isErlaubnisZurEinaescherungViewOnly(documentID);

        if (!imageID) {
            if (viewOnlyErlaubnis) {
                makeToast('Die Erlaubnis zur Einäscherung ist hier nur zur Ansicht verfügbar und wird vom Krematorium bereitgestellt, sobald sie vorliegt.');
            } else {
                this.takeImageOptions = {
                    documentid: documentID,
                    documenttype: documentType
                };
                setReadonlyOnInputsToState(false, false);
                openCameraWithID('takePictureField');
            }
            return;
        }

        if (viewOnlyErlaubnis) {
            this.loadBurialDocumentForPreview(documentID, documentType, imageID);
            return;
        }

        if (confirm('Dokument bereits vorhanden, mit OK wird das vorhandene Dokument angezeigt, mit Abbrechen kann ein neues Dokument gespeichert werden')) {
            this.loadBurialDocumentForPreview(documentID, documentType, imageID);
        } else {
            this.takeImageOptions = {
                documentid: documentID,
                documenttype: documentType
            };
            setReadonlyOnInputsToState(false, false);
            openCameraWithID('takePictureField');
        }
    }

    takeImageCallbackSend(requestType: RestApiEndpoints, postBody: any) {


        if (!requestType || !postBody) { 
            console.error('Fehlende Parameter:', { requestType, postBody });
            makeToast('Fehler: Ungültige Parameter');
            return; 
        }

        // Session-Überprüfung
        const sessionID = localStorage.getItem('sessionID');
        const sessionToken = localStorage.getItem('sessionToken');

        if (!sessionID || !sessionToken) {
            console.error('Keine gültige Session gefunden');
            makeToast('Fehler: Keine gültige Session. Bitte erneut anmelden.');
            return;
        }

        if (this.credentialService.humanID) {
            if (postBody.hasOwnProperty('burialData')) {
                postBody.burialData.humanID = this.credentialService.humanID;
            } else {
                postBody.humanID = this.credentialService.humanID;
            }
        }

        if (this.credentialService.humanName) {
            if (postBody.hasOwnProperty('burialData')) {
                postBody.burialData.humanName = this.credentialService.humanName;
            } else {
                postBody.humanName = this.credentialService.humanName;
            }
        }

        this.isLoading = true;

        this.restApiService.sendAsyncRequestToEndpoint(requestType, postBody, (success, response) => {
            this.isLoading = false;

            if (!success) {
                console.error('API-Fehler:', response);
                makeToast('Fehler beim Speichern: ' + (response?.message || 'Unbekannter Fehler'));
                return;
            }

            if (response.success) {
                makeToast('Dokument erfolgreich gespeichert');
                // Aktualisiere die Ansicht
                this.reloadBurials();
            } else {
                console.error('API-Fehler:', response);
                makeToast('Dokument konnte nicht gespeichert werden: ' + (response?.message || 'Unbekannter Fehler'));
            }
        });
    }

    takeImageCallback(fieldID: string) {
        const fileElement: any = document.getElementById(fieldID);
        if (!fileElement) { return; }

        if (this.takeImageOptions?.documentid && this.isErlaubnisZurEinaescherungViewOnly(this.takeImageOptions.documentid)) {
            fileElement.value = '';
            makeToast('Die Erlaubnis zur Einäscherung kann nicht durch das Bestattungsunternehmen hochgeladen werden.');
            return;
        }

        setReadonlyOnInputsToState(this.modalService.shouldBeReadOnly, false);

        var that = this;
        this.fileService.convertFileArrayToBaseArray(fileElement.files, function (baseArray: any) {
            fileElement.value = '';

            if (!baseArray || baseArray.length < 1) { return; }

            var requestType = null;
            var postBody: any = null;
            if (that.takeImageOptions.documenttype == 'application') {
                var applicationID = that.selectedApplication.burialData.qrstring;

                if (!applicationID) { return; }

                var imageKey = that.takeImageOptions.documentid;
                var imageString = baseArray[0].payload;
                that.fileService.convertImagesToPDF(imageString, function (imageStringConverted: any) {
                    that.applications = that.burialsService.writeDokumentInApplicationArray(applicationID, that.applications, imageKey, imageStringConverted);
                    that.didSelectApplicationWithID(applicationID);
                    requestType = RestApiEndpoints.addContract;
                    postBody = that.selectedApplication;
                    that.takeImageCallbackSend(requestType, postBody);
                });
            } else if (that.takeImageOptions.documenttype == 'burial') {
                var applicationID = that.selectedBurial.fid;

                if (!applicationID) { return; }

                var imageKey = that.takeImageOptions.documentid;
                var imageString = baseArray[0].payload;
                that.fileService.convertImagesToPDF(imageString, function (imageStringConverted: any) {
                    postBody = {};
                    requestType = RestApiEndpoints.addDocument;
                    postBody.fid = applicationID;
                    postBody[imageKey] = imageStringConverted;
                    that.takeImageCallbackSend(requestType, postBody);
                });
            }
        });
    }

    openPDFFromHistory(pdfString: string) {
        window.open(pdfString);
    }

    importContractClicked() {
        const fileElement = document.getElementById('importField');
        if (fileElement) {
            fileElement.click();
        }
    }

    importContractCallback(fieldID: string) {
        const fileElement: any = document.getElementById(fieldID);
        if (!fileElement) { return; }

        this.isLoading = true;
        this.fileService.importFiles(Array.from(fileElement.files), () => {
            this.isLoading = false;
            fileElement.value = '';
            this.reloadBurials();
        });
    }

    openHistoryButtonClicked(historyType: string) {
        this.historyEntries = [];
        var selectedGUID = null;

        switch (historyType) {
            case 'application':
                selectedGUID = this.selectedApplication.burialData.qrstring;
                break;
            case 'burial':
                selectedGUID = this.selectedBurial.v_qrstring;
                break;
        }

        if (!selectedGUID) {
            makeToast('Laden der Historie nicht möglich');
            return;
        }

        var postBody = {
            guid: selectedGUID
        };

        openModalWithID('historymodal');
        this.isHistoryLoading = true;

        this.restApiService.sendAsyncRequestToEndpoint(RestApiEndpoints.loadHistory, postBody, (success, response) => {
            this.isHistoryLoading = false;

            if (!success) {
                makeToast('Verbindungsfehler, bitte erneut versuchen');
                return;
            }

            if (response.success && response.payload) {
                this.historyEntries = this.burialsService.prepareHistoryArray(response.payload.reverse());
            }
        });
    }

    isDraftSending(postBody: any) {
        var currentDrafts = this.modalService.loadDataObjectsFromDrafts();
        if (currentDrafts && postBody && postBody.hasOwnProperty('burialData') && postBody.burialData.hasOwnProperty('qrstring') && postBody.burialData.qrstring) {
            var currentQRString = postBody.burialData.qrstring;
            for (var currentDraftIndex in currentDrafts) {
                var currentDraft = currentDrafts[currentDraftIndex];
                if (currentDraft && currentDraft.hasOwnProperty('burialData') && currentDraft.burialData.hasOwnProperty('qrstring') && currentDraft.burialData.qrstring) {
                    var compareQRString = currentDraft.burialData.qrstring;
                    if (currentQRString == compareQRString) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    sendDataButtonClicked(isAfterGive?: boolean) {
        if (!this.isApplicationOnline) {
            makeToast('Neue Aufträge können nur gesendet werden wenn die Anwendung online ist');
            return;
        }

        this.agreementTextColor = 'black-text';
        var postBody = this.modalService.getModalData();

        if (!postBody.burialData.inputName) {
            makeToast('Bitte einen Vornamen angeben');
            return;
        }

        if (!postBody.burialData.inputLastName) {
            makeToast('Bitte einen Nachnamen angeben');
            return;
        }

        const deceasedAddrEmpty = (v: any) => !v || !String(v).trim();
        if (deceasedAddrEmpty(postBody.burialData.inputStreet)) {
            makeToast('Bitte die Straße der/des Verstorbenen angeben (erforderlich für die Einäscherung)');
            return;
        }
        if (deceasedAddrEmpty(postBody.burialData.inputZip)) {
            makeToast('Bitte die PLZ der/des Verstorbenen angeben (erforderlich für die Einäscherung)');
            return;
        }
        if (deceasedAddrEmpty(postBody.burialData.inputCity)) {
            makeToast('Bitte den Wohnort der/des Verstorbenen angeben (erforderlich für die Einäscherung)');
            return;
        }

        if (!this.inputAgreement) {
            makeToast('Bitte die Gewährleistung bestätigen');
            this.agreementTextColor = 'red-text';
            return;
        }

        if (!this.isDraftSending(postBody)) {
            postBody = this.modalService.getModalData(true);
        }
        postBody.burialData.herkunft = "Bestatter-Login 2";

        if (this.credentialService.humanID) {
            postBody.burialData.humanID = this.credentialService.humanID;
        }

        if (this.credentialService.humanName) {
            postBody.burialData.humanName = this.credentialService.humanName;
        }

        if (!this.inputSendMail) {
            postBody.burialData.sendMail = 0;
        } else {
            postBody.burialData.sendMail = 1;
        }

        var alternativeID = null;

        const inputAddLocation = this.credentialService.parseElementBy(ElementAttribute.class, 'inputAddLocation');
        if (inputAddLocation) {
            alternativeID = inputAddLocation.value;
        }
       
        const adoptionDateTimeWish = this.credentialService.parseElementBy(ElementAttribute.class, 'adoptionDateTimeWish');
        if (adoptionDateTimeWish) {
            var value = adoptionDateTimeWish.value;
            var adoptionDateTimeWishArray = value.split(' ');
            if (value.length > 1) {
              postBody.burialDates.adoptionDateWish = adoptionDateTimeWishArray[0];
              postBody.burialDates.adoptionTimeWish = adoptionDateTimeWishArray[1];
            }
        }
        const driveServiceDateTimeWishFrom = this.credentialService.parseElementBy(ElementAttribute.class, 'driveServiceDateTimeWishFrom');
        if (driveServiceDateTimeWishFrom) {
            var value = driveServiceDateTimeWishFrom.value;
            var adoptionDateTimeWishArray = value.split(' ');
            if (value.length > 1) {
              postBody.burialDates.driveServiceDateWishFrom = adoptionDateTimeWishArray[0];
              postBody.burialDates.driveServiceTimeWishFrom = adoptionDateTimeWishArray[1];
            }
        }

        const driveServiceDateTimeWishTo = this.credentialService.parseElementBy(ElementAttribute.class, 'driveServiceDateTimeWishTo');
        if (driveServiceDateTimeWishTo) {
            var value = driveServiceDateTimeWishTo.value;
            var adoptionDateTimeWishArray = value.split(' ');
            if (value.length > 1) {
              postBody.burialDates.driveServiceDateWishTo = adoptionDateTimeWishArray[0];
              postBody.burialDates.driveServiceTimeWishTo = adoptionDateTimeWishArray[1];
            } 
        }

        const anonymousBurialSiteDateTimeWish = this.credentialService.parseElementBy(ElementAttribute.class, 'anonymousBurialSiteDateTimeWish');
        if (anonymousBurialSiteDateTimeWish) {
            var value = anonymousBurialSiteDateTimeWish.value;
            var adoptionDateTimeWishArray = value.split(' ');
            if (value.length > 1) {
              postBody.burialDates.anonymousBurialSiteDateWish = adoptionDateTimeWishArray[0];
              postBody.burialDates.anonymousBurialSiteTimeWish = adoptionDateTimeWishArray[1];
            }
        }


        if (!alternativeID || alternativeID == 0) {
            alternativeID = localStorage.getItem('sessionID');
        }

        postBody.alternativeID = alternativeID;

        this.isLoading = true;
        this.restApiService.sendAsyncRequestToEndpoint(RestApiEndpoints.addContract, postBody, (success, response) => {
            this.isLoading = false;

            if (!success) {
                makeToast(response);
                return;
            }

            if (response.success) {
                // Wenn es sich um einen Entwurf handelt, lösche ihn aus localStorage
                if (this.isDraftSending(postBody)) {
                    this.modalService.deleteDataObjectFromDrafts(postBody);
                    this.drafts = this.modalService.loadDataObjectsFromDrafts();
                }
                
                handleTempModalData('null');

                this.router.navigate(['/dash/burials']);
                window.location.reload();

                if (!isAfterGive) {
                    closeModalWithID('burialaddmodal');
                } else {
                    closeModalWithID('burialdetailmodal');
                }
                this.reloadBurials();
            } else {
                makeToast('Antrag konnte nicht eingetragen werden, bitte erneut versuchen');
            }
        });
    }

    draftDataButtonClicked(isAfterGive?: boolean) {
        var postBody = this.modalService.getModalData();

        if (postBody && postBody.hasOwnProperty('burialData') && postBody.burialData.hasOwnProperty('qrstring')) {
            this.printAfterSaveID = postBody.burialData.qrstring;
        }

        this.sendDataButtonClicked(isAfterGive);
    }

    saveAsDraftButtonClicked() {
        var postBody = this.modalService.getModalData();

        // Validierung: Mindestens Vorname und Nachname müssen vorhanden sein
        if (!postBody.burialData.inputName) {
            makeToast('Bitte einen Vornamen angeben');
            return;
        }

        if (!postBody.burialData.inputLastName) {
            makeToast('Bitte einen Nachnamen angeben');
            return;
        }

        // Stelle sicher, dass qrstring vorhanden ist
        if (!postBody.burialData.qrstring) {
            this.modalService.updateQRCode();
            postBody = this.modalService.getModalData();
        }

        // Speichere als Entwurf
        var result = this.modalService.saveDataObjectAsDraft(postBody);

        if (result.success) {
            // Zeige Erfolgs-Toast
            if (result.oldestDeleted) {
                makeToast('Entwurf gespeichert. Ältester Entwurf wurde automatisch gelöscht.');
            } else {
                makeToast(result.message);
            }

            // Aktualisiere Entwürfe-Liste
            this.drafts = this.modalService.loadDataObjectsFromDrafts();

            // Setze selectedApplication auf den neu gespeicherten Entwurf, damit
            // "Bearbeiten / Senden" sofort ohne Seiten-Reload funktioniert
            var newDraft = this.burialsService.parseApplicationByID(postBody.burialData.qrstring, this.drafts);
            if (newDraft) {
                this.selectedApplication = newDraft;
                this.selectedApplication.isDraft = true;
                this.selectedBurial = null;
            }

            // Modal nur per Angular-State schließen (kein closeModalWithID – das kann ein
            // Materialize-Overlay zurücklassen und Klicks blockieren)
            this.isDialogOpen = false;
            this.changeDetectorRef.detectChanges();

            // Initialisiere Collapsible-Verhalten neu, damit neue Entwürfe ausklappbar sind
            setTimeout(() => {
                initCollapsible();
                initFormsDropDown();
            }, 100);

            // Setze Modal-Daten zurück
            handleTempModalData('null');
        } else {
            // Zeige Fehler-Toast
            makeToast(result.message);
        }
    }

    cancelDataButtonClicked() {
        if (this.isDialogOpen) {
            // Zeige Bestätigungsdialog
            this.isConfirmDialogOpen = true;
            this.changeDetectorRef.detectChanges();
        }
    }

    cancelCloseModal() {
        if (this.isConfirmDialogOpen) {
            this.isConfirmDialogOpen = false;
            this.changeDetectorRef.detectChanges();
        }
    }

    confirmCloseModal() {
        if (this.isConfirmDialogOpen) {
            this.isConfirmDialogOpen = false;
            this.changeDetectorRef.detectChanges();
        }
        if (this.isDialogOpen) {
            // Beim Schließen ohne Speichern: Felder leeren, damit Firefox sie nicht speichert
            this.clearAllInputFieldsInModal();
            this.isDialogOpen = false;
            this.changeDetectorRef.detectChanges();
        }
    }

    private clearAllInputFieldsInModal() {
        // Liste aller Input-Felder, die geleert werden müssen
        const inputFields = [
            'inputLastName',
            'inputName',
            'inputBirthName',
            'inputStreet',
            'inputZip',
            'inputCity',
            'inputBirthDate',
            'inputBirthPlace',
            'inputDeathDate',
            'inputDeathTime',
            'inputDeathPlace',
            'inputBurialPlace',
            'registryOffice',
            'registryOfficeNumber',
            'inputReturnDate',
            'inputReturnTime',
            'inputReturnLastName',
            'inputReturnName',
            'inputReturnStreet',
            'inputReturnZip',
            'inputReturnCity',
            'inputClientLastName',
            'inputClientName',
            'inputClientStreet',
            'inputClientZip',
            'inputClientCity',
            'inputUrnStyle',
            'inputBurialInfo',
            'inputDespatchID'
        ];

        // Alle Input-Felder leeren
        inputFields.forEach(fieldClass => {
            const field = this.credentialsService.parseElementBy(ElementAttribute.class, fieldClass);
            if (field) {
                field.value = '';
            }
        });

        // Select-Felder auf Standardwert zurücksetzen
        const selectFields = [
            { id: 'inputGender', defaultValue: '0' },
            { id: 'inputReturnType', defaultValue: '0' },
            { id: 'inputClientSalutation', defaultValue: '0' },
            { id: 'inputUrnType', defaultValue: '0' }
        ];

        selectFields.forEach(selectField => {
            setSelectValue(selectField.id, selectField.defaultValue);
        });

        // Materialize Textfelder aktualisieren
        updateMaterialTextFields();
    }

    downloadCurrentDocumentClicked() {
        this.fileService.downloadCurrentPDFDocument();
    }

    imageFieldHoverToggle(imageField: any) {
        if (imageField) {
            this.hoveredImageField = imageField;
        } else {
            this.hoveredImageField = null;
        }
    }

    droppedFiles(fileArray: any) {
        //alert('Ping Pong');
    }

    deleteContractButtonClicked(contractType: string) {
        var qrString = this.selectedApplication.burialData.qrstring;

        var deleteResult = confirm('Diesen Auftrag wirklich löschen?');

        if (deleteResult == false || !contractType || !qrString) { return; }

        switch (contractType) {
            case 'draft':
                this.modalService.deleteDataObjectFromDrafts(this.selectedApplication);
                this.reloadBurials();
                break;
            case 'application':
                var postBody = {
                    guid: cleanInput(qrString, true)
                };

                this.isLoading = true;
                this.restApiService.sendAsyncRequestToEndpoint(RestApiEndpoints.deleteContract, postBody, (success, response) => {
                    this.isLoading = false;

                    if (!success) {
                        makeToast(response);
                        return;
                    }

                    if (response.success) {
                        this.reloadBurials();
                    } else {
                        makeToast('Fehler beim Löschen, bitte erneut versuchen');
                    }
                });
                break;
        }
    }

    burialSearchChanged() {
        initCollapsible();
    }

    burialsTabClicked(tabName: BurialLayoutType) {
        this.credentialService.burialLayoutType = tabName;

        switch (tabName) {
            case BurialLayoutType.infos:
                this.router.navigate(['/dash/burials/home']);
                break;
            default:
                this.router.navigate(['/dash/burials/personal_data']);
                break;
        }
    }

    loadMoreButtonClicked() {
        this.reloadBurials(true);
    }

    

     didChangeLocation(isBackgroundTask?: boolean) {
        const inputLocation = this.credentialService.parseElementBy(ElementAttribute.class, 'inputLocation');
        if (!inputLocation) { return; }

        this.currentAlternativeID = inputLocation.value;

        const inputAddLocation = this.credentialService.parseElementBy(ElementAttribute.class, 'inputAddLocation');
        if (!inputAddLocation) { return; }

        inputAddLocation.value = this.currentAlternativeID;

        if (!this.currentAlternativeID || this.currentAlternativeID == '0') {
            this.currentAlternativeID = localStorage.getItem('sessionID');
        }

        this.reloadBurials();

     //   var tmpApplicationsArray: any = [];
     //   var tmpBurialsArray: any = [];
/*
        for (var tmpApplicationsIndex in this.tmpApplications) {
            if (this.tmpApplications[tmpApplicationsIndex].burialData.locationID && this.tmpApplications[tmpApplicationsIndex].burialData.locationID != this.currentAlternativeID) { continue; }
            tmpApplicationsArray.push(this.tmpApplications[tmpApplicationsIndex]);
        }

        for (var tmpBurialsIndex in this.tmpBurials) {
            if (this.tmpBurials[tmpBurialsIndex].s_locationID && this.tmpBurials[tmpBurialsIndex].s_locationID != this.currentAlternativeID) { continue; }
            tmpBurialsArray.push(this.tmpBurials[tmpBurialsIndex]);
        }
*/
      // if (!isBackgroundTask && tmpApplicationsArray.length < 1 && tmpBurialsArray < 1) {
            //this.reloadBurials(true);
    //        return;
     //   }

     //   this.applications = tmpApplicationsArray;
      //  this.burials = tmpBurialsArray;
        initCollapsible();

       // if (!isBackgroundTask) {
       //     this.changeDetectorRef.detectChanges();
       // }

       /* await this.databaseService.applications.toArray().then(applicationsFromDatabase => {
            let castedApplications: Application[] = [];

            const fidsFromDatabase = applicationsFromDatabase.flatMap(applicationFromDatabase => { return (applicationFromDatabase as any).fid; });

            for (const tmpApplication of tmpApplicationsArray) {
                let isApplicationInDatabase = false;

                for (const fidFromDatabase of fidsFromDatabase) {
                    if (fidFromDatabase == tmpApplication.fid) {
                        isApplicationInDatabase = true;
                    }
                }

                if (!isApplicationInDatabase) {
                    castedApplications.push(tmpApplication as Burial);
                }
            }

            this.databaseService.burials.bulkAdd(castedApplications);
        });

        await this.databaseService.burials.toArray().then(burialsFromDatabase => {
            let castedBurials: Burial[] = [];

            const fidsFromDatabase = burialsFromDatabase.flatMap(burialFromDatabase => { return (burialFromDatabase as any).fid; });

            for (const tmpBurial of tmpBurialsArray) {
                let isBurialInDatabase = false;

                for (const fidFromDatabase of fidsFromDatabase) {
                    if (fidFromDatabase == tmpBurial.fid) {
                        isBurialInDatabase = true;
                    }
                }

                if (!isBurialInDatabase) {
                    castedBurials.push(tmpBurial as Burial);
                }
            }

            this.databaseService.burials.bulkAdd(castedBurials);
        });*/
    }

    printContractWithSignature(labelType: string) {
        this.currentPrintLabelType = labelType;
        
        // Öffne das Modal zuerst
        openModalWithID('signaturemodal');
        
        // Warte auf das nächste Event-Loop-Tick, um sicherzustellen, dass das Modal vollständig geöffnet ist
        setTimeout(() => {
            // Initialisiere die SignaturePads
            this.initializeSignaturePads();
            
            // Setze die Canvas-Größe für beide SignaturePads
            const bestatterCanvas = document.getElementById('bestatterSignature') as HTMLCanvasElement;
            const angehoerigerCanvas = document.getElementById('angehoerigerSignature') as HTMLCanvasElement;
            
            if (bestatterCanvas && this.bestatterSignaturePad) {
                const ratio = Math.max(window.devicePixelRatio || 1, 1);
                bestatterCanvas.width = bestatterCanvas.offsetWidth * ratio;
                bestatterCanvas.height = bestatterCanvas.offsetHeight * ratio;
                bestatterCanvas.getContext('2d')?.scale(ratio, ratio);
                this.bestatterSignaturePad.clear();
            }
            
            if (angehoerigerCanvas && this.angehoerigerSignaturePad) {
                const ratio = Math.max(window.devicePixelRatio || 1, 1);
                angehoerigerCanvas.width = angehoerigerCanvas.offsetWidth * ratio;
                angehoerigerCanvas.height = angehoerigerCanvas.offsetHeight * ratio;
                angehoerigerCanvas.getContext('2d')?.scale(ratio, ratio);
                this.angehoerigerSignaturePad.clear();
            }
        }, 100);
    }

    printContractButtonClicked(labelType: string) {
        if (labelType == null) { return; }

        // Direkt drucken ohne Unterschrift
        this.printContractAfterSignatures(labelType);
    }

    saveSignatures() {
        // Prüfe ob Signaturen vorhanden sind und initialisiere sie leer wenn nicht unterschrieben
        if (this.bestatterSignaturePad && !this.bestatterSignaturePad.isEmpty()) {
            this.bestatterSignature = this.bestatterSignaturePad.toDataURL();
        } else {
            this.bestatterSignature = '';
        }
        
        if (this.angehoerigerSignaturePad && !this.angehoerigerSignaturePad.isEmpty()) {
            this.angehoerigerSignature = this.angehoerigerSignaturePad.toDataURL();
        } else {
            this.angehoerigerSignature = '';
        }
        
        
        closeModalWithID('signaturemodal');
        
        // Nach dem Speichern der Unterschriften, drucke den Auftrag
        this.printContractAfterSignatures(this.currentPrintLabelType);
    }
    
    private printContractAfterSignatures(labelType: string) {
        switch (labelType) {
            case 'application':
                this.isOptionsLoading = true;

                const applicationPayload = {
                    ...this.selectedApplication,
                    bestatterSignature: this.bestatterSignature,
                    angehoerigerSignature: this.angehoerigerSignature
                };

                var that = this;
                this.pdfService.createDocumentOfType('RTK.Antrag', applicationPayload, function (result: any) {
                    that.isOptionsLoading = false;

                    if (!result) { return; }

                    if (!that.isIEBrowser) {
                        openModalWithID('filedetailmodal');
                        that.filePreviewObject = result;
                    }

                    initFormsDropDown();
                });

                break;
            case 'burial':
                this.isOptionsLoading = true;

                // Erstelle ein erweitertes Payload-Objekt mit Unterschriften und selectedBurial
                const burialPayload = {
                    ...this.selectedBurial,
                    bestatterSignature: this.bestatterSignature,
                    angehoerigerSignature: this.angehoerigerSignature
                };

                var that = this;
                this.pdfService.createDocumentOfType('RTK.Antrag', burialPayload, function (result: any) {
                    that.isOptionsLoading = false;

                    if (!result) { return; }

                    if (!that.isIEBrowser) {
                        openModalWithID('filedetailmodal');
                        that.filePreviewObject = result;
                    }

                    initFormsDropDown();
                });
                break;
        }
    }

    printCasketLabelButtonClicked(labelType: string) {
        if (labelType == null) { return; }

        switch (labelType) {
            case 'application':
                this.isOptionsLoading = true;

                var that = this;
                this.pdfService.createDocumentOfType('Sargkarte', this.selectedApplication, function (result: any) {
                    that.isOptionsLoading = false;

                    if (!result) { return; }

                    if (!that.isIEBrowser) {
                        openModalWithID('filedetailmodal');
                        that.filePreviewObject = result;
                    }

                    initFormsDropDown();
                });

                break;
            case 'burial':
                this.isOptionsLoading = true;

                var that = this;
                this.pdfService.createDocumentOfType('Sargkarte', this.selectedBurial, function (result: any) {
                    that.isOptionsLoading = false;

                    if (!result) { return; }

                    if (!that.isIEBrowser) {
                        openModalWithID('filedetailmodal');
                        that.filePreviewObject = result;
                    }

                    initFormsDropDown();
                });

                break;
        }
    }

    printPickupButtonClicked(typeID: string) {
        if (typeID == null) { return; }

        switch (typeID) {
            case 'application':
                this.isOptionsLoading = true;

                var that = this;
                this.pdfService.createDocumentOfType('Überführung', this.selectedApplication, function (result: any) {
                    that.isOptionsLoading = false;

                    if (!result) { return; }

                    if (!that.isIEBrowser) {
                        openModalWithID('filedetailmodal');
                        that.filePreviewObject = result;
                    }

                    initFormsDropDown();
                });
                break;
            case 'burial':
                this.isOptionsLoading = true;

                var that = this;
                this.pdfService.createDocumentOfType('Überführung', this.selectedBurial, function (result: any) {
                    that.isOptionsLoading = false;

                    if (!result) { return; }

                    if (!that.isIEBrowser) {
                        openModalWithID('filedetailmodal');
                        that.filePreviewObject = result;
                    }

                    initFormsDropDown();
                });
                break;
        }
    }

    sendContractButtonClicked() {
        //TODO: This function has not been implemented in the old project, but it is called from the view... Whats this?
    }

    openDocumentTab(id: string) {
        const url = this.router.serializeUrl(this.router.createUrlTree([`documents/${id}`]));
        window.open(url, '_blank');
    }

    fullName(): string {
        return this.credentialService.fullName ?? '';
    }

    fullLastName(): string {
        return this.credentialService.fullLastName ?? '';
    }

    selectedTab(): SelectedBurialsTab | undefined {
        return this.modalService.selectedTab;
    }

    showPersonalData(): boolean {
        if (this.modalService.selectedTab && this.modalService.selectedTab == SelectedBurialsTab.personalData) { return true; }
        return false;
    }

    showDetailSendButton(): boolean {
        if (this.modalService.selectedTab && this.modalService.selectedTab == SelectedBurialsTab.urnDelivery) { return true; }
        return false;
    }

    filterButtonClicked() {
        openModalWithID('filtermodal');
        initBurialsApplicationValues();

        this.filterInputContractNames = [];

        this.burials.forEach(burial => {
            const burialContractName = burial.contractName;

            if (!this.filterInputContractNames.includes(burialContractName)) {
                this.filterInputContractNames.push(burialContractName);
            }
        });
    }

    searchButtonClicked() {
        openModalWithID('searchmodal');
        initBurialsApplicationValues();
    }

    clearSearchButtonClicked() {
        this.inputSearchText = '';
        closeModalWithID('searchmodal');
        this.macGyveredDOMReload();
    }

    addFilterValue(type: string, value?: any) {
        if (type === 'inputFilterStatus') {
            const selectElement = document.getElementById('inputFilterStatus') as HTMLSelectElement;
            if (selectElement && selectElement.value !== '0') {
                this.filterValues.push(new FilterValue(selectElement.value, FilterValueType.status));
                selectElement.value = '0';
            }
        } else if (type === 'inputFilterEntry') {
            const inputElement = document.getElementById('inputFilterEntry') as HTMLInputElement;
            if (inputElement && inputElement.value) {
                this.filterValues.push(new FilterValue(inputElement.value, FilterValueType.entryDate));
                inputElement.value = '';
            }
        } else if (type === 'inputFilterBurial') {
            const inputElement = document.getElementById('inputFilterBurial') as HTMLInputElement;
            if (inputElement && inputElement.value) {
                this.filterValues.push(new FilterValue(inputElement.value, FilterValueType.burialDate));
                inputElement.value = '';
            }
        } else if (type === 'Status' && value) {
            this.filterValues.push(new FilterValue(value, FilterValueType.status));
        } else if (type === 'Entry' && value) {
            this.filterValues.push(new FilterValue(value, FilterValueType.entryDate));
        } else if (type === 'Burial' && value) {
            this.filterValues.push(new FilterValue(value, FilterValueType.burialDate));
        }
        this.updateFilterMatchCount();
    }

    deleteFilterValue(filterValue: FilterValue) {
        this.filterValues = this.filterValues.filter(compareFilterValue => { return compareFilterValue.value != filterValue.value || compareFilterValue.type != filterValue.type; })
        this.updateFilterMatchCount();
        this.macGyveredDOMReload();
    }

    deleteAllFilters() {
        this.filterValues = [];
        this.filterMatchCount = 0;
        this.macGyveredDOMReload();
    }

    private updateFilterMatchCount() {
        const allItems = [...this.burials, ...this.applications, ...this.drafts];
        const filteredItems = allItems.filter(item => {
            let matchingFilters = 0;
            for (const filter of this.filterValues) {
                if (!filter || !filter.value) continue;

                switch (filter.type) {
                    case FilterValueType.status:
                        if (item && item.htmlHeaderClass && filter.value === item.htmlHeaderClass) {
                            matchingFilters++;
                        }
                        break;
                    case FilterValueType.entryDate:
                        if (item) {
                            const dateFields = [item.created_at, item.auftrag_erstellt, item.entryDate];
                            for (const dateField of dateFields) {
                                if (dateField && this.dateService.onlyDateFromDateTimeString(dateField) === filter.value) {
                                    matchingFilters++;
                                    break;
                                }
                            }
                        }
                        break;
                    case FilterValueType.burialDate:
                        if (item) {
                            const dateFields = [item.burial_date, item.burialdate, item.cremationDate];
                            for (const dateField of dateFields) {
                                if (dateField && this.dateService.onlyDateFromDateTimeString(dateField) === filter.value) {
                                    matchingFilters++;
                                    break;
                                }
                            }
                        }
                        break;
                }
            }
            return matchingFilters === this.filterValues.length;
        });
        this.filterMatchCount = filteredItems.length;
    }

    macGyveredDOMReload() {
        /* Be careful, the following code is MacGyvered-Black-Magic-Voodoo-Stuff! 
            Don't read this, don't write this, or you will get haunted by a ghost... Also don't try this at home!
            Viewer discretion is adviced! :-) */

        const tmpBurials = this.burials;
        this.burials = [];
        setTimeout(() => {
            this.burials = tmpBurials;
            this.burialSearchChanged();
            this.updateFilterMatchCount();
        }, 1);
    }

    clearSignature(type: 'bestatter' | 'angehoeriger') {
        if (type === 'bestatter' && this.bestatterSignaturePad) {
            this.bestatterSignaturePad.clear();
        } else if (type === 'angehoeriger' && this.angehoerigerSignaturePad) {
            this.angehoerigerSignaturePad.clear();
        }
    }

    closeSignatureModal() {
        closeModalWithID('signaturemodal');
    }

}
